import { Button, Space } from 'antd'
import { useRouteMatch } from 'react-router'
import { LinkButton } from '~/components/LinkButton'
import { MenuEdit } from './MenuEdit'

export function AdminDashboard (): JSX.Element {
  const match = useRouteMatch()
  // const [loading, setLoading] = useState(false)

  // const handleSaveFilesToDisk = async (): Promise<void> => {
  //   setLoading(true)
  //   try {
  //     const response = await saveFilesToDisk({})
  //     const success = (response as { success: boolean }).success
  //     const msg = (response as { message: string }).message
  //     if (success) {
  //       message.success(msg).then(() => {}, console.error)
  //     } else {
  //       message.error(msg).then(() => {}, console.error)
  //     }
  //   } catch (e) {
  //     message
  //       .error('An unexpected error occurred.')
  //       .then(() => {}, console.error)
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  return (
    <section>
      <Space>
        <LinkButton
          component={Button}
          type='primary'
          to={`${match.url}/page/add`.replace(/\/+/g, '/')}
        >
          Create Page
        </LinkButton>
        <LinkButton
          component={Button}
          type='primary'
          to={`${match.url}/category/add`.replace(/\/+/g, '/')}
        >
          Create Category
        </LinkButton>
        <LinkButton
          component={Button}
          type='primary'
          to={`${match.url}/sermon/`.replace(/\/+/g, '/')}
        >
          Manage Sermons
        </LinkButton>
        <LinkButton
          component={Button}
          type='primary'
          to={`${match.url}/user/`.replace(/\/+/g, '/')}
        >
          Manage Users
        </LinkButton>
        {/* <Button
          type='primary'
          loading={loading}
          onClick={handleSaveFilesToDisk}
          disabled
        >
          Save Files to Disk
        </Button> */}
      </Space>
      <MenuEdit />
    </section>
  )
}
